import React from "react";
import BeneficiryBase from "../../components/beneficiary/BeneficiaryBase";
import Sidebar from "../../components/sidebar/Sidebar";
import TrusteeBase from "../../components/trustee/TrusteeBase";
import UserBase from "../../components/user/UserBase";
import { getUser } from "../../services/user-service";
import DocumentList from "./DocumentList";
import OrganizationBase from "../organization/OrganizationBase";

function DocumentRoute() {
    let role = getUser().role;

    if (role === "BENEFICIARY") {
        return (
            <BeneficiryBase>
                <div className="mt-5"></div>
                <Sidebar>
                    <DocumentList />
                </Sidebar>
            </BeneficiryBase>
        );
    }

    else if (
        role === "USER" ||
        (role === "ORG_USER" &&
            (getUser().accountType === "primary" ||
                getUser().accountType === "secondary"))
    ) {
        return (
            <UserBase>
                <div className="mt-5"></div>
                <Sidebar>
                    <DocumentList />
                </Sidebar>
            </UserBase>
        );
    }

    else if (role === "TRUSTEE") {
        return (
            <TrusteeBase>
                <div className="mt-5"></div>
                <Sidebar>
                    <DocumentList />
                </Sidebar>
            </TrusteeBase>
        );
    }

    else if (role === "TENANT_ADMIN" || role === "TENANT_USER") {
        return (
            <OrganizationBase>
                <div className="mt-5"></div>
                <Sidebar>
                    <DocumentList />
                </Sidebar>
            </OrganizationBase>
        );
    }

    return null;
}

export default DocumentRoute;